<template>
  <div>
    <v-row class="ml-4">
      <v-col cols="8" md="8">
        <div class="tes-card__title header mb-5">
          Подключение электронного ЕПД
        </div>
        <div class="d-flex helvetica fs-16">
          Для ежемесячного получения квитанции на оплату ЖКУ на <br />
          электронную почту заполните обязательные поля ниже
        </div>
      </v-col>
    </v-row>
    <v-form class="mt-7 auth-form" ref="form" v-model="valid" lazy-validation>
      <v-row class="ml-4 mt-5">
        <v-col cols="8" md="2">
          <span class="helvetica-medium mr-3 fs-16 d-inline-block"
            >Лицевой счёт:</span
          >
        </v-col>

        <v-col cols="8" md="4">
          <v-text-field
            type="number"
            :rules="domHozRules"
            outlined
            v-model="personalAccount"
            :disabled="loading"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ml-4">
        <v-col cols="8" md="2">
          <span class="helvetica-medium mr-3 fs-16 d-inline-block"
            >ФИО потребителя (полностью):</span
          >
        </v-col>
        <v-col cols="8" md="4">
          <v-text-field
            outlined
            :rules="fioRules"
            v-model="fio"
            :disabled="loading"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ml-4">
        <v-col cols="8" md="2">
          <span class="helvetica-medium mr-3 fs-16 d-inline-block"
            >Электронная почта:</span
          >
        </v-col>
        <v-col cols="8" md="4">
          <v-text-field
            v-model="email"
            :rules="emailRules"
            outlined
            required
            :disabled="loading"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <div v-show="personalAccount">
      <v-row class="ml-4">
        <v-col cols="8" md="3">
          <v-flex xs12>
            <h3 class="mb-3 fs-18">Проверка безопасности</h3>
          </v-flex>
          <v-flex xs12>
            <div class="d-flex flex-column">
              <span class="custom-hint" v-if="customHint"
                >Неверно. Пожалуйста, введите новый код с картинки</span
              >
              <div class="d-flex justify-center" v-if="!captchaHash">
                <v-progress-circular indeterminate color="#ff721c" />
              </div>

              <div id="captcha"></div>
              <span @click="loadCaptcha" class="link">Обновить</span>
              <span>Введите код, изображенный на картинке:</span>
              <v-text-field
                v-model="captchaInput"
                outlined
                :rules="captchaRules"
                required
                :disabled="loading"
              />
            </div>
          </v-flex>
        </v-col>
      </v-row>
    </div>
    <v-row class="ml-3">
      <v-col cols="7" md="7">
        <v-checkbox
          v-model="epdAgreement"
          color="success"
          class="personal-agreement-checkbox float-left mt-0 pt-0"
          required
          :disabled="loading"
        ></v-checkbox>
        <span
          class="agreement-text-holder helvetica-light fz-16"
          ref="checkboxLabel"
        >
          Я согласен получать электронный единый платежный документ по
          электронной почте и отказаться от единого платежного документа в
          бумажном виде
        </span>
      </v-col>
    </v-row>
<v-row class="ml-3">
      <v-col cols="12" md="7">
        <div class="mb-7">
          <v-checkbox v-model="personalRead"
                      color="success"
                      class="personal-agreement-checkbox float-left mt-0 pt-0"
                      required
                      :disabled="loading"></v-checkbox>
          <span class="agreement-text-holder helvetica-light fz-16"
                ref="checkboxLabel">
            Ознакомлен(а) с
            <a href="http://tatenergosbyt.ru/about/personal-policy/"
               target="blank">положением об обработке персональных данных</a>
          </span>
        </div>
        <div>
          <v-checkbox v-model="personalAgreement"
                      color="success"
                      class="personal-agreement-checkbox float-left mt-0 pt-0"
                      required
                      :disabled="loading"></v-checkbox>
          <span class="agreement-text-holder helvetica-light fz-16"
                ref="checkboxLabel">
            Даю
            <a href="#" @click.prevent="showAgreementDialog = true">согласие на обработку персональных данных</a>
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="ml-6 mt-4">
      <v-btn
        class="green-button white--text"
        @click="connect"
        :disabled="
          !valid || !epdAgreement || !personalAgreement || !captchaInput
        "
        :loading="loading"
        >Подключить</v-btn
      ></v-row
    >

    <PersonalAgreementDialog
      :dialog="showAgreementDialog"
      @closeDialog="closeAgreementDialog"
    />

    <modal
      v-if="showModal"
      :show="showModal"
      :header="headerModal"
      :text="textModal"
      @change="closeModal"
    />

  <modal-guest-application
      v-if="applicationModal"
      :show="applicationModal"
      :domHoz="domHozModal"
      :email="emailModal"
      :header="headerModal"
      @change="closeApplicationModal"
    />
  </div>
</template>
<script>
import axios from "axios";
import PersonalAgreementDialog from "../../components/common/PersonalAgreementDialog";
import Modal from "../../components/modals/ModalTKO";
import ModalGuestApplication from "../../components/modals/ModalGuestApplication";

export default {
  layout: "guest",
  name: "guest-connection-epd",
  components: { PersonalAgreementDialog, Modal, ModalGuestApplication},
  data: () => ({
    personalAccount: null,
    fio: null,
    email: null,
    customHint: false,
    captchaHash: "",
    captcha: "",
    valid: false,
    captchaInput: "",
    epdAgreement: false,
    personalAgreement: false,
    personalRead: false,
    showAgreementDialog: false,
    showModal: false,
    loading: false,
    headerModal: "Уважаемый клиент!",
    textModal: "",
    emailModal: null,
    domHozModal: null,
    applicationModal: false,
    captchaRules: [(v) => !!v || "Введите символы, изображенные на картинке"],
    fioRules: [(v) => !!v || "Укажите фамилию, имя и отчество",
      (v) => /^[А-Яа-яёЁ\s\-."]+$/.test(v) || "Введены недопустимые символы"
    ],
    emailRules: [
      (v) => !!v || "Укажите e-mail",
      (v) =>
        /^[^'"\|`~{}\[\]\/()\\=,<>\s\t]+$/.test(v) ||
        "Введены недопустимые символы",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Введите корректный e-mail",
    ],
    domHozRules: [
      (v) => !!v || "Введите число",
      (v) => +v >= 0 || "Ожидается номер лицевого счета",
      (v) => typeof +v === "number" || "Ожидается номер лицевого счета",
      (v) => v.length === 10 || "Ожидаемая длина 10 символов",
    ],
  }),
  methods: {
    loadCaptcha() {
      this.customHint = false;
      this.captchaHash = "";
      this.captcha = "";

      delete axios.defaults.headers.common["Authorization-Token"];
      delete axios.defaults.headers.common["Authorization"];

      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/captcha-endpoint.ashx?get=html&c=yourFirstCaptchaStyle",
          {
            data: {},
            headers: {
              "Content-Type": "text/plain",
            },
          }
        )
        .then((resp) => {
          this.captcha = this.changeRelativeToAbsoluteUrls(resp.data);
          document.getElementById("captcha").innerHTML = this.captcha;
          if (!this.searchIsExist && this.FindErrorCount > 3) {
            document.getElementById("captcha2").innerHTML = this.captcha;
          }
          this.captchaHash = this.getCaptchaId();
        });
    },
    getCaptchaId() {
      return document.getElementById("BDC_VCID_yourFirstCaptchaStyle").value;
    },
    // украдено с https://github.com/captcha-com/reactjs-captcha
    changeRelativeToAbsoluteUrls(originCaptchaHtml) {
      let captchaEndpointHandler = "captcha-endpoint.ashx";
      let backendUrl = process.env.VUE_APP_API_URL + "/";

      originCaptchaHtml = originCaptchaHtml.replace(/<script.*<\/script>/g, "");
      let relativeUrls = originCaptchaHtml.match(/(src|href)=\"([^"]+)\"/g);

      let relativeUrl,
        relativeUrlPrefixPattern,
        absoluteUrl,
        changedCaptchaHtml = originCaptchaHtml;

      for (var i = 0; i < relativeUrls.length; i++) {
        relativeUrl = relativeUrls[i]
          .slice(0, -1)
          .replace(/src=\"|href=\"/, "");
        relativeUrlPrefixPattern = new RegExp(".*" + captchaEndpointHandler);
        absoluteUrl = relativeUrl.replace(
          relativeUrlPrefixPattern,
          backendUrl + captchaEndpointHandler
        );
        changedCaptchaHtml = changedCaptchaHtml.replace(
          relativeUrl,
          absoluteUrl
        );
      }

      return changedCaptchaHtml;
    },
    closeAgreementDialog() {
      this.showAgreementDialog = false;
    },
    validate() {
      return !!this.$refs.form.validate();
    },
    connect() {
      if (this.validate()) {
        axios
          .post(process.env.VUE_APP_API_URL + "/SendCaptcha", {
            CaptchaId: this.captchaHash,
            UserEnteredCaptchaCode: this.captchaInput,
          })
          .then((resp) => {
            console.log(resp);
            if (!resp.data.success) {
              this.loadCaptcha();
              this.customHint = true;
            } else {
              this.customHint = false;
              this.loadCaptcha();
              this.checkLS();
            }
          });
      }
    },
    checkLS() {
      this.loading = true;

      this.$store
        .dispatch("guest/CheckLS", {
          domHoz: this.personalAccount,
          fio: this.fio,
          email: this.email,
        })
        .then((response) => {
          this.showModal = true;
          this.textModal = response.text ? response.text : response.message;

          if (response.clear) {
            this.clear();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeModal() {
      this.showModal = false;
    },
    closeApplicationModal() {
      this.applicationModal = false;
      this.emailModal = null;
      this.domHozModal = null;
    },
    clear() {
      this.personalAccount = null;
      this.fio = null;
      this.email = null;
      this.epdAgreement = false;
      this.personalAgreement = false;
      this.personalRead = false;
      this.captchaInput = "";
    },
    checkToken() {
      let href = window.location.href;
      let hasCode = href.indexOf("token=") >= 0;

      if (!hasCode) {
        return;
      }

      let arr = href.split("=");
      let token = arr[arr.length - 1];

      this.applicationModal = true;

      this.$store
        .dispatch("guest/setApplicationForElectronicReceiptGuest", {
          token: token,
        })
        .then((response) => {
          if (response.success) {
            this.emailModal = response.email;
            this.domHozModal = response.domHoz;
          } else {
            this.applicationModal = false;
          }
        });
    },
  },
  mounted() {
    this.checkToken();
    this.loadCaptcha();
    this.validate();
  },
};
</script>
<style scoped>
.header {
  font-size: 36px;
}
.link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}
.custom-hint {
  color: red;
}
</style>
